// src/components/PageLayout.jsx
import { Box, Typography } from '@mui/joy';
import BreadcrumbsNav from './BreadcrumbsNav';

const PageLayout = ({ title, children, fullWidth = false }) => {
  return (
    <Box
      sx={{
        p: 4,
        borderRadius: 2,
        bgcolor: 'background.level1',
        minHeight: '100vh',
        flexGrow: 1,
        overflowX: 'hidden',
        ...(fullWidth
          ? { width: '100%', maxWidth: '9000px', mx: 'auto' }
          : { maxWidth: 'lg', mx: 'auto' }),
      }}
    >
      <BreadcrumbsNav />
      <Typography level="h1" color="success" sx={{ mb: 4 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default PageLayout;